import { combineReducers } from 'redux';

import brandInfo, { BrandInfoState } from './modules/brand-info';
import carousel, { ICarouselState } from './modules/carousel';
import display, { DisplayState } from './modules/display';
import inventory, { InventoryState } from './modules/inventory';
import inventory_filter_data, { InventoryFilterDataState } from './modules/inventory_filter_data';
import { NewArrivalsReducer, NewArrivalsReduxState } from './modules/NewArrivals';
import shopify, { State } from './modules/shopify';
import { VintageInstrumentsReducer, VintageInstrumentsReduxState } from './modules/VintageInstruments';

export interface IRootState {
    brandInfo: BrandInfoState;
    carousel: ICarouselState;
    display: DisplayState;
    inventory: InventoryState;
    inventory_filter_data: InventoryFilterDataState;
    NewArrivalsReducer: NewArrivalsReduxState;
    VintageInstrumentsReducer: VintageInstrumentsReduxState;
    shopify: State;
}

/**
 * Import your reducers here, and add them as keys in the combineReducers call below.
 */
export default combineReducers<IRootState>({
    NewArrivalsReducer,
    VintageInstrumentsReducer,
    brandInfo,
    carousel,
    display,
    inventory,
    inventory_filter_data,
    shopify
});



// WEBPACK FOOTER //
// ./src/redux/root_reducer.ts